import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { trackPageView } from '@snowplow/browser-tracker'

import { useAuth } from '@/contexts/AuthContext'

import { PAGE_PATHS } from '@/services/paths'
import { getUnityUA, persistUnityUAFromURL } from '@/services/unityUA'

interface PublicProps {
  children: React.ReactNode
  unityAgent?: string
}

const Public = ({ children, unityAgent }: PublicProps) => {
  const router = useRouter()
  const { loadingUser, signed, embedded } = useAuth()

  useEffect(() => {
    trackPageView({ title: router.asPath })
  }, [router.asPath])

  useEffect(() => {
    persistUnityUAFromURL()
  }, [])

  useEffect(() => {
    if (loadingUser || !router.isReady) return

    if (signed) {
      const ids = typeof router.query.ids === 'string' ? router.query.ids : ''

      const embeddedQuery = router.query.embedded === 'true'

      const isEmbedded = embedded === true || embeddedQuery || Boolean(ids)

      if (isEmbedded) {
        const params = new URLSearchParams()

        const ua =
          typeof router.query['x-unity-user-agent'] === 'string'
            ? router.query['x-unity-user-agent']
            : unityAgent || getUnityUA() || ''

        const lng = typeof router.query.lng === 'string' ? router.query.lng : ''

        const collectionId =
          typeof router.query.collectionId === 'string'
            ? router.query.collectionId
            : ''

        const canSaveCollection =
          typeof router.query.canSaveCollection === 'string'
            ? router.query.canSaveCollection
            : ''

        const from =
          typeof router.query.from === 'string' ? router.query.from : ''

        if (ids) params.set('ids', ids)
        if (ua) params.set('x-unity-user-agent', ua)
        if (lng) params.set('lng', lng)
        if (collectionId) params.set('collectionId', collectionId)

        if (canSaveCollection) {
          params.set('canSaveCollection', canSaveCollection)
        }

        if (from) params.set('from', from)

        const query = params.toString()

        router.replace(`${PAGE_PATHS.embedded}${query ? `?${query}` : ''}`)

        return
      }

      router.replace(PAGE_PATHS.home)
    }
  }, [loadingUser, signed, unityAgent, embedded, router.isReady, router.query])

  return !loadingUser && !signed && children
}

export default Public
